// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s5-c";
export var backButton = "_s5-4";
export var backIcon = "_s5-5";
export var chevronShortcut = "_s5-6";
export var container = "_s5-1";
export var editor = "_s5-8";
export var editorWrapper = "_s5-7";
export var prefix = "_s5-2";
export var searchIcon = "_s5-3";
export var suffix = "_s5-9";
export var suffixContent = "_s5-a";
export var suffixText = "_s5-b";
export var wrapper = "_s5-0";